import de from "./de";

export default {
  // Allgemein
  language_picker_helper: "Choose a language",
  languages: {
    english: "English",
    german: "German",
    spanish: "Spanish",
    french: "French"
  },
  languagesCodes: {
    english: "GB",
    german: "DE",
    spanish: "ES",
    french: "FR"
  },
  langcodeShort: "GB",
  langcode: "en-EN",
  messagesLanguage: "Notification language",
  greeting: "Hello",
  unexpectedError: "An unexpected error occured!",
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  sunday: "Sunday",
  username: "Username",
  password: "Password",
  logout: "Log out",
  since: "since",
  clock: "Clock",
  oClock: "",
  back: "Back",
  deviceConfig: "Open device configuration",
  active: "Active",
  inactive: "Inactive",
  save: "Save",
  absence: "Absence",
  requestable: "Requestable",
  unpaidAbsence: "unpaid absence",
  userIsWorkingInProject: "The User is currently working in a project",
  all: "All",
  delete: "Delete",
  send: "send",
  date: "Date",
  search: "Search",
  legend: "Legend",
  time: "Time",
  comment: "Comment",
  passwordNoMatch: "Passwords do not match",
  passwordTooShort: "Password is too short",
  resetPassOnLogin: "Reset password on login",
  cancel: "Cancel",
  passwordSaved: "Password saved",
  changePasswordQuestion: "Do you want to change your password",
  insertPassword: "Insert password",
  confirmPassword: "Confirm password",
  insertAdminPassword: "Admin password insert",
  confirm: "Confirm",
  history: "History",
  workTime: "Work Time",
  pause: "Break",
  monthlyWorkTime: "Monthly Worktime",
  showDeletedBookingLines: "Show deleted bookings",
  hideDeletedBookingLines: "Hide deleted bookings",
  addTime: "Add Timestamp",
  project: "Project",
  add: "Add",
  changeTime: "Change timestamp",
  timestamp: "Timestamp",
  duration: "Duration",
  coming: "Coming",
  going: "Going",
  businessTrip: "Business trip",

  changeLine: "Change line",
  timeOverlapse: "Time overlapse with another Bookingline",
  timeToBigFor: "The time can't be bigger than",
  be: "be",
  editBookingLineWithoutComment: "Do you really want to add a Bookingline without a comment",
  timeNotEntered: "Time has not been entered",
  statusNotEntered: "Status has not been entered",
  worktimeIs: "Work Time is",
  pauseTimeIs: "Break Time is",
  accept: "Accept",
  decline: "Decline",
  declined: "Declined",
  reason: "Reason",
  absenceReason: "absence reason",
  prevDay: "Previous day",
  nextDay: "Next day",
  prevMonth: "Previous month",
  nextMonth: "Next month",
  successfullyTransmitted: "Successfully transmitted",
  cobiServerNotRunning: "COBI.time Server cannot be reached!",
  cobiServerUp: "Connection to COBI.time Server successfully restored",
  finished: "finished",
  or: "or",
  started: "started",
  hrs: "hours",
  activity: "Activity",
  noRight: "User has no rights",
  publicHolidays: "public holidays",
  publicHoliday: "Public holiday",
  state: "Country/ State",
  import: "import",
  changesWillBeLostMessage: "Any unsaved changes will be lost",
  workDay: "Work day",
  request: "Request",
  select: "Select",
  month: "Month",
  year: "Year",
  publicHolidaysLetter: "H",
  workDayLetter: "W",
  vacation: "Vacation",
  changes: "Changes",
  added: "Added",
  edited: "Edited",
  deleted: "Deleted",
  errorByUser: "Error by user",
  from: "from",
  until: "until",
  attachments: "Attachments",
  location: "Location",
  showAll: "Show all",
  settings: "Settings",
  reset: "reset",
  darkMode: "dark mode",
  lightMode: "light mode",
  resetAll: "Reset all",
  discardSelected: "Discard selected",
  half: "half",
  halfDay: "half day",
  fullDay: "full day",
  startValue: "Start value",
  timeOff: "Time Off",
  close: "Close",
  refresh: "Refresh",
  management: "Management",
  selected: "{0} selected",

  // MainMenu
  avgWorkingHours: "Avg. working hours",
  avgBreakTime: "Avg. break time",
  overtime: "Overtime",
  nonBillableTime: "Non-billable time",
  logoutWarning: "Are you sure you want to log out?",
  onSwitch: "on",
  offSwitch: "off",
  yes: "yes",
  no: "no",

  // Auth
  userPin: "Userpin",
  resetPass: "Reset password",
  RFIDScannerText: "Scan started",
  PleasePresentRFIDChip: "Please present RFID-Chip",
  RFIDNumberNotFound: "RFID-Number not found!",
  RFIDRegistration: "RFID-Chip registration",
  RFIDReset: "Reset RFID-Chip",

  // FaceLogin.vue
  faceFound: "Face found! Try login",
  faceLoginHelp: "Please hold still until the face recognition is finished!",
  pleaseEnterPin: "Please enter PIN!",
  enterPin: "Enter PIN",
  employeeNotRecognized: "Employee not recognized!",
  faceLoginRestarting: "Facerecognition is restarting",

  // Menu.vue
  timekeeping: "Timekeeping",
  manualTimekeeping: "Manual Timekeeping",
  administration: "Administration",
  presencelist: "Presence List",
  mainmenu: "Main menu",

  // Usermenu.vue
  notifications: "Notifications",
  noNotification: "No notification received",
  newNotification: "new notifications",
  openNotification: "Open notifications",
  unread: "Unread",
  userFunctions: "Userfunctions",
  showHistory: "Show History",
  absenceRequest: "Absence request",
  timeCorrectionRequest: "Time correction request",
  timeCorrectionRequestNotFound: "Time correction request was not found",

  noTimeBookedForThisDate: "No bookings for this day",
  undoClue: "Do you really want to reset changes?",
  deleteTimeLineClue: "Are you sure you want to delete the line?",

  changePic: "Change Picture",
  noPictureUploaded: "No picture has been uploaded",
  profilePictureNotSaved: "Could not upload the profile picture. (Wrong format or picture too big - 2mb max)",
  messages: "Messages",
  subject: "Subject",
  chooseMessage: "Please choose a Message",
  deleteMessagesQuestion: "Do you really want to delete the messages",
  markAllAsReadQuestion: "Do you really want to mark all messages as read",
  userInfo: "User info",
  timeCorrection: "Time correction",
  timeCorrectionWasSuccessfulApproved: "Time correction request was successfully approved",

  // Status
  absent: "Absent",
  present: "Present",
  inproject: "In Project",
  inServiceCall: "In service call",
  inpause: "In Break",
  break: "Break",

  // Administration
  userAdministration: "User Administration",
  generalSettings: "General Settings",
  changeLogo: "Change logo",
  resetLogo: "Reset logo",
  upload: "Upload",
  absenceReasons: "Absence reasons",
  manage: "Manage",
  factorAuth: "2 Factor Authentication (Face & Pin)",
  absenceAdministration: "Absence Administration",
  importSapUser: "Import SAP User",
  importUser: "Import User",
  editUser: "Edit User",
  projectAdministration: "Project Administration",
  sapUserCodeIsMissingError: "The user {0} is missing the SAP user code!",
  sapUserExtIdError: "external employee number for user {0} is too long!",
  userWithSameCodeError: "Benutzer mit dem gleichen SAP Benutzercode ist schon vorhanden",
  settingSuccessfulSaved: "Setting was saved successfully!",
  TimeAccountRecalculation: "Recalculate time accounts",
  startTimeAccountRecalculation: "start recalculation",
  timeAccountAlreadyRecalculateError: "Timeaccounts are already recalculating",
  publicHolidaysAdministration: "Public Holidays Administration",
  projectManagement: "Projectstages",
  serviceCalls: "Service-Calls",
  permissionsAndAssignments: "Permissions and Assignments",
  searchForBusinessPartner: "Search for Business Partner Name or Code",
  editProjectStagesFor: "Edit Project stages for",
  editServiceCallsFor: "Edit Service Calls for",

  //Settings.vue
  stageProjectsAllowed: "Activate booking on projects from the project management?",
  settingsWasSaved: "Settings were saved",
  stageProjectsWithoutPermissions: "Activate authorization system for projects from the project management?",
  showFinanceProjectByProjectManagement: "Display financial projects name by project management?",
  serviceCallsAllowed: "Activate booking on service calls? ",
  serviceCallsWithoutPermissions: "Activate the authorization system for service calls? ",
  showAbsenceApprovalsInPresentList: "Show absence requests in the presence list",
  financeProjectsAllowed: "Activate posting to financial projects?",
  colorCode: "Color code",
  icon: "Icon",
  allowProjectComment: "Allow Project Comments",
  showCostCentre: "Show cost center",
  showNewTimeCorrection: "Show new time correction",
  hideCommentByTimeCorrection: "Hide comment field by time correction",
  defaultState: "Default Setting for country/state",
  showBusinessTripByTimeKeeping: "Show 'business trip' button by time recording",
  showBusinessTripByTimeKeepingOnlyIfItsApproved: "Show 'business trip' button for time recording only if a business trip is approved for that day",
  startRecalculationRequest: "Do you really want to start recalculating for Timeaccounts? This will take some time!",
  selectRecalculationDate: "Please select date. From this date, all time accounts will be recalculated",
  resetAdminPassword: "Reset admin password",
  allowUserCloseOpenBooking: "Users can close open booking",
  requireLocation: "Require location selection",
  automaticLocationByRFID: "Automatic location detection by RFID",
  chooseLocation: "Select location",
  settingsTitle: "Settings",
  settingsTabGeneral: "General",
  settingsTabSecurity: "Security",
  settingsTabTimeManagement: "Time Management",
  settingsTabProjects: "Projects",
  settingsTabServiceCalls: "Service Calls",
  settingsTabBusinessTrips: "Business Trips",
  settingsTabCalculation: "Calculation",
  timeAccountsWarningGeneral:
    "Warning: Initiates a system-wide recalculation of all time accounts. The process may take longer and impact system performance. Do you wish to proceed?",
  startRecalculationRequest: "Start time account recalculation?",
  timeAccountsWarningText:
    "Warning! This action starts a full recalculation of all time accounts in the system. The process may take time and temporarily slow down the interface.",

  //EditUser
  validFrom: "Valid from:",
  validUntil: "Valid until:",
  timeModel: "Time model",
  autoModel: "Automatic model",
  startTimeHours: "Start value hours",
  dateNoSelectedError: "Date not selected",
  vacationDays: "Vocation days",
  userRightInfo: "The user can access time recording and book working time.",
  projectUserRightInfo: "The user is able to book times on projects.",
  projectManagerRightInfo: "The user can access the manual time recording and post times in the past.",
  userManagerRightInfo: "User can access the user administration and the project administration / servicecalls administration.",
  presencelistRightInfo: "The user only sees members from the team/ department in the presence list.",
  cheifPresencelistRightInfo: "The user can see all employees in the presence list.",
  timesCorrectionRightInfo: "The user can correct working time.",
  seeTimesRightInfo: "The user has the right to view the working time of other employees.",
  pauseAndProjectTimeCorrectionRight: "The user can correct own project and break times.",
  canChangeBusinessTripTimeInfo: "The user can post business trip",
  notEnoughHolidaysLeft: "Not enough vacation days",
  groupSaveSuccessful: "Groups for user {0} were saved successfully!",
  editHolidayAccount: "Edit holiday account",
  closingTimeAccountInPastWarning:
    "Please note, if you add or delete public holidays here, all time accounts will be updated. This can be a long process and it is advisable to only perform the operation when no user is online. You can check on this page when the procedure is complete.",
  timeAccountForDateAlreadyExist: "There is already a time account for the selected date",

  // UserGroups
  user: "User",
  bookTimes: "Book Times",
  projectTime: "Book Project Times",
  projectUser: "Manual Time Recording",
  userManager: "Administration",
  manualTimekeeping: "Manual Time Recording",
  presentListUser: "Presence List (Team)",
  presentListChef: "Presence List (All)",
  timeCorrection: "Time Correction",
  reviewWorkTime: "Views Times",
  reviewWorkTimeTeam: "View Times (Team)",
  projectAndPauseTimeManipulation: "Adjust Project and Break Times",
  canChangeBusinessTripTime: "Post Business Trips",
  userRights: "User Rights",
  canAccessManagement: "Management",
  canAccessAbsenceOverview: "Absence overview",
  canAccessAbsenceOverviewTeam: "Absence overview (Team)",
  canAccessGeneralReporting: "General reporting",
  canAccessGeneralReportingTeam: "General reporting (Team)",

  //UserAdministration
  userHasNoTeam: "User has no SAP team",
  userInSAPNotFound: "User not found in SAP",
  employeeIsInactiveInSAP: "User is inactive in SAP",
  userHasActiveTimeAccount: "User can't be deleted as long as a timeaccount is active",
  userHasActiveHolidayAccount: "User can't be deleted as long as a holidayaccount is active",
  userDeleteMessage: "Do you really want to deactivate the following user:",
  holidayDeleteMessage: "Do you really want to delete the following Holiday:",
  activateUser: "Activate user",
  deactivateUser: "Deactivate user",
  deleteUser: "Delete user",
  edit: "Edit",
  resetPassword: "Reset password",
  showInactiveUser: "show inactive user",
  hideInactiveUser: "hide inactive user",
  usersSuccessfulDelete: "Users were successfully deactivated",
  userCodeLengthError: "User code cannot be longer than 20 characters",
  resetRFIDMessage: "Do you really want to reset the RFID?",
  rfidSuccessfullyReset: "RFID was successfully reset",
  rfidCodeAllreadyExists: "RFID is already in use",
  rfidSuccessfullyAdded: "RFID was successfully added",
  team: "Team",

  //Public Holidays
  sameDateForHolidaysError: "An absence for this Date already exists",
  addNewHoliday: "Create a new holiday",
  deleteHolidayMessage: "Are you sure you want to remove the following holiday?",
  importHolidays: "Import public holidays",
  editPublicHolidays: "Edit Holidays",
  holidaySuccessfulDeletedMessage: "Holiday was successfully deleted",
  enterHolidayName: "Enter name",
  sameHolidayDateError: "An absence has already been entered for {0}",
  holidaysWarning:
    " Warning! If you add or delete holdays in here, every timeaccount gets updated! This is a long process. Execute this process only when no User is online! You can check the progress of this action on this site after you emitted it.",
  saveHolidayMessage: "Do you wish to save your changes?",
  takeOverHolidayToNextYear: "Take over into the next year",
  timeAccountsRecalculateAlert: "Zeitkonten werden neu berechnet. Bitte warten sie!",
  holidaysBookingProcess: "Speicherung ist nicht möglich! Zeitkonten werden gerade neu berechnet",
  holidaysNameLengthError: "Holiday name cannot be longer than 100 characters",

  // ManualTimekeeping.vue
  monthlyHistory: "Monthly History",
  chooseProject: "Choose a Project",
  chooseActivity: "Choose a Activity",
  chooseFinancialProject: "Choose financial Project",
  chooseCustomer: "Choose a Business Partner",
  chooseServiceCall: "Choose a Servicecall",
  recordTime: "Re-record Time",
  chooseProjectError: "Please choose a project",
  chooseStageError: "Please choose a service call",
  bookingError: "More than 24h have passed since the last booking entry. Please edit the correct timestamp.",
  WorkAlreadyStartedError: "Arbeitstag wurde schon gestartet",
  WorkWasNotStartedError: "Arbeitstag muss erst gestartet werden",
  PauseAlreadyStartedError: "Pause wurde schon gestartet",
  PauseWasNotStartedError: "Pause wurde noch nicht gestartet",
  ProjectAlreadyStartedError: "Projekt wurde schon gestartet",
  ProjectWasNotStartedError: "Projekt wurde noch nicht gestartet",
  financeProjects: "Finance Projects",
  selectTime: "Select Time",
  resetInputs: "Reset Entries",

  //BelatedStatus:
  commentIsEmpty: "comment is missing!",
  correctBooking: "Correct Booking Entry",
  deleteBookingLineWarning: "Do you really want to delete the booking entry?",

  // Presencelist.vue
  attendancestatus: "Attendancestatus",
  presentInfoText: "A green little man or a green colored card shows that the employee is currently working",
  inPauseInfoText: "A yellow coffee symbol shows that the employee is currently in a break",
  absentInfoText: "A red little man or a red colored card shows that the employee is currently not at work",
  showLegend: "Show legend",
  timeDot: "Time",
  showOnlyPresentEmployee: "Show only present Employees",
  searchHere: "Type in to search",
  switchToTableMode: "Switch to Table Mode",
  switchToCardMode: "Switch to Card Mode",
  employeeInProject: "The Employee is working on a project",
  hideDeletedBookings: "Hide deleted bookings",
  showDeletedBookings: "Show deleted bookings",
  editHistory: "Edit history",
  showComments: "Show comments",
  absenceErrorByBookingLinesCorrection: "There is an absence for date: {0}",
  sameTimeError: "Less than a minute has passed since the last booking",
  addNewBookingLine: "Add new line",
  presencelistInfoIsDeprecated: "Presence information is out of date",
  noTimeAccountLineForDay: "No time account for this day",
  noRightForStartAndEndTimeCorrection: "User has no rights to correct start and end times",
  noRightForPauseTimeCorrection: "User has no rights to correct break times",
  noRightForProjectTimeCorrection: "User has no rights to correct project times",
  presentOnly: "Present only",
  searchUser: "Search User",

  // MobileQuickAccess
  quickAccess: "Quick Access",
  savePageOrder: "Saving your new page-order...",
  reOrderEnabled: "You may now re-order the pages.",

  // MobileTimeReport
  vacationUsed: "used",
  vacationUnconfirmed: "pending",
  vacationOpen: "available",

  // MobilePresenceList
  showFilterOptions: "Show Filter Options",
  hideFilterOptions: "Hide Filter Options",

  //EmployeeInformation
  pauseTimeDebit: "Pausetime left",

  // UserSettings.vue
  enableAbsenceEmailNotifications: "Receive Email notifications when users from your Team create an absence request",

  // Simpleclient.vue
  employee: "Employee",
  employees: "Employees",
  nonBillableTime: "Non Chargeable Time",
  startTime: "Start Time",
  endTime: "End Time",
  pauseStart: "Break Start",
  pauseEnd: "Break End",
  projectStart: "Project Start",
  projectEnd: "Project End",
  activityStart: "Activity start",
  activityEnd: "Activity end",
  activityType: "Activity Type",
  startBusinessTrip: "Business trip start",
  endBusinessTrip: "Business trip end",
  financeProject: "Finance Project",
  serviceCallBusinessPartner: "Servicecall BP",
  serviceCall: "Service Call",
  sumPause: "Break Sum",
  sumWorkTime: "Worktime sum",
  serviceCallCustomer: "Customer",
  costCentre: "Cost Centre",
  postWorktime: "Post Worktime",
  dateInFuture: "Date is in the future",
  dateMissing: "Date is missing",
  startTimeMissing: "Starttime is missing",
  endTimeMissing: "Endtime is missing",
  endTimeBeforeStart: "Endtime before starttime",
  pauseEndBeforeStart: "Break endtime before Break starttime",
  pauseStartMissing: "Break starttime is missing",
  pauseEndMissing: "Break endtime is missing",
  pauseStartAndEndBeforeStart: "Break start and endtime needs to be after starttime",
  pauseStartAndEndAfterEnd: "Break start and endtime needs to be before endtime",
  worktimeAdded: "Worktime added",
  simpleClientErrorAbsences: "Cannot proceed; An absence was entered for this date",
  timePeriodsOverlapError: "Cannot proceed; Time periods from another booking overlaps",
  pausesOverlapError: "Break times overlap",
  effectiveTimeError: "Effective work time must be equal to or greater than zero",
  notTimeAccountForUserError: "No time account was created for this user",
  dateOutOfTimeAccountRange: "Date is out of time account valid range",
  ProjectStageNotSelected: "Stage is missing",
  stageIsRequired: "Stage is required!",
  serviceCallIsRequired: "ServiceCall is required!",
  activityIsRequired: "Activity is required!",

  // Start.vue
  configure: "Configure",
  deviceMode: "Device Mode",
  terminalMode: "Terminal Mode",

  // UserMessageDialog.vue
  receivedOn: "Received on",
  readUnread: "Mark as Read / Unread",
  unread: "Unread",
  mailUpdated: "Mail Updated",

  // AbsenceDialog.vue
  sendAbsence: "Send absence",
  requestAbsence: "Request absence",
  chooseAbsenceRange: "Please choose an Absencerange",
  absenceRequestSuccess: "Absence successfully requested",
  timeRequestSuccess: "Time correction successfully requested",
  wrongFileFormat: "Wrong file format",
  userHaveNoManagerOrRepresentative: "user have no manager or representative",

  // AbsenceCalendar.vue
  absenceType: "Absence types",
  colorLegend: "Color Legend",
  vacationRequestsConfirmed: "Vacation requests not yet confirmed",
  absenceOverview: "Absence Overview",
  showColorLegend: "Show color Legend",
  absenceNeedToConfirm: "Absence has yet to be confirmed",
  hideColorLegend: "Hide color Legend",
  normalWorkDay: "Normal Workday",
  closedTimeaccountWorkDay: "Closed time account",
  showWorkTime: "Show worktime",
  acceptAbsenceWarning: "Do you want to accept the Absence request",
  declineAbsenceWarning: "Do you want to decline the Absence request",
  absenceFromAccept: "Do you really want to accept the Absence",
  absenceFromDecline: "Do you really want to decline the Absence",
  fromTheEmployee: "from the Employee",
  savingAbsences: "Saving absences to Database",
  absencesSaved: "Absencereasons successfully updated",
  getAbsences: "Getting Absencereasons from SAP",
  saveAbsence: "Save Absence",
  absenceOverlapError: "Absencedates overlap with other Absences!",
  notEnoughVacationDays: "Employee has not enough vacation days",
  NotEnoughVacationDaysForUser: "{0} has not enough vacation days",

  //AbsenceOverview
  remainingHoliday: "Remaining Vacation",
  changesOverview: "Changes overview",
  addedAbsences: "Added absences",
  deletedAbsences: "Deleted absences",
  approvedAbsences: "Accepted absences",
  declinedAbsences: "Declined absences",
  changedAbsences: "Changed absences",
  selectedDays: "Selected Days",
  absencesForApproval: "Absences for approval",
  absenceAprrovalReasonLengthError: "Reason cannot be longer than 100 characters",
  chooseAbsencetype: "choose absence type",
  absenceIsPast: "Absence change for {0} is not possible. The change is far in the past ",
  userHasNoTimeAccountLineForDay: "User {0} has no Timeaccount for selected date {1}",
  shiftSelectHint: "Hold Shift + Left Click to select a date range",

  // About.vue
  licenseValidUntil: "License valid until",
  noExpiryDate: "No expiry Date",

  // History.vue
  statusWorkStart: "Work started",
  statusWorkEnd: "Work finished",
  statusPauseStart: "Break started",
  statusPauseEnd: "Break finished",
  usergroups: "Usergroups",
  userRights: "User Rights",
  getSAPUsers: "Getting SAP users",
  importSAPUsers: "Importing SAP Users",
  startPassword: "Please choose a password",
  noUserSelected: "No User selected",
  userSuccessfullyCreated: "User successfully created",
  sapExternalUser: "SAP external Employeecode",
  sapUserCode: "SAP Usercode",
  startPass: "One Time Start Password",
  sapImport: "Import employees",
  name: "Name",
  settingsSaved: "Settings saved successfully",
  chooseSettings: "Please select every setting",
  timeErrorLastBookingLine: "Attention: Please wait 1 Minute to perform a new booking. Do you want to remove the last Booking?",
  deleteBookingLineQuestion: "Do you want to delete the last bookingline",
  startPause: "Successfully started the break",
  endPause: "Successfully stopped the break",
  endPauseTime: "The breaktime is: ",
  startProject: "Successfully started working on the project: {0}",
  endProject: "Successfully stopped working on the project",
  startWork: "Successfully started work",
  endWork: "Successfully ended the work! The worktime is: {0}",
  newProjectLogic: "Stageprojects",
  endWorkWithoutTime: "Successfully ended the work!",
  chooseStage: "Choose Project Stage",
  chooseActivity: "Choose activity",
  stage: "Project Level",
  editWorkTimeAccount: "Edit working time account",
  worktimeAccounts: "Working time account",
  projects: "Projects",
  projectPermissions: "Project stages Permissions and Assignments",
  dataSendSuccessfully: "Data has been send successfully",
  timeModelDeleted: "Dailymodel deleted successfully",
  activeWeekModelError: "Delete/Edit not possible! There is a weekmodel with this dailymodel!",
  activeTimeAccountError: "Delete/Edit not possible! There is an active time account with this weekmodel!",
  weekModelDeleted: "Weekmodel deleted successfully",
  weekModelWithoutNameNotAllowed: "Weekmodel needs a name.",
  timeAccountIs: "Timeaccount balance",
  noTimeAccountSet: "No Timeaccount registered",
  timeAccountNotAccurate: "Timeaccount calculation takes place the next day",
  deleteTimeAccount:
    "Do you really want to deactivate the timeaccount? The account will be closed with the currently booked time. Open bookings will be removed!",
  closeTimeAccount: "Close timeaccount",
  absenceForDayExists: "There is an absence for this day",
  workTimeHover: "Work time",
  pauseTimeHover: "Break time",
  projectTimeHover: "Project time",
  bookedSumIs: "Work hours today",
  bookedSumDebit: "Sollstunden",
  difference: "difference",
  showOvertimeDetails: "show details",
  hideOvertimeDetails: "hide details",
  projectStarted: "Project {0} started",
  serviceCallStarted: "Servicecall {0} started",
  serviceCallFinished: "Servicecall {0} finished",
  costCenterStarted: "Activity started (Cost Center: {0})",
  costCenterFinished: "Activity finished (Cost Center: {0})",
  commentLengthError: "Comment cannot be longer than 400 characters",
  saveChangeRequest: "Möchten Sie die Änderungen wirklich speichern?",
  noProjectSelected: "Noch kein Projekt ausgewählt!",
  noTimeAccountForDay: "There is no time account for this day",
  timeSheetCannotBeEdited: "Timesheet cannot be updated. The working time has already been billed in SAP for that day.",
  comments: "Comments",
  editedBy: "Edited by",
  before: "Before",
  after: "After",
  on: "on",
  at: "at",
  selectComment: "Select comment",
  autoModelTip: "Automatic Model",
  closedTimeaccount: "Closed Timeaccount",
  timeWasSuccessfullyCorrected: "Time was successfully corrected",
  timeAccountCorrection: "Time account correction",
  timeAccountCorrectionsForDay: "Balance correction",
  timeAccountCorrectionSuccess: "Balance was successfully corrected",
  editTimeAccountDebit: "edit balance",
  editor: "Editor",
  correctionValue: "Correction value",
  sum: "Sum",

  // Models
  excludePeriods: "Exclude periods",
  deleteWeekModelMessage: "Do you really want to delete the weekly {0} model?",
  everyWeek: "every week",
  everySecondWeek: "every second week",
  everyThirdWeek: "every third week",
  monthly: "monthly",
  editAutoWeeklyModel: "edit automatic model",
  nextAutoDayDate: "next booking date",
  firstBookingDate: "First booking date",
  autoModelNextDateError: "Next booking date for {0} is not valid",
  autoModelChangeHint: "You cannot change this model because it is already assigned to an employee. Please create a new model",
  autoModelChangeWarning: "After you add this model to a user, it can't be changed. Continue?",
  fixedBreakTimes: "Fixed break times",
  totalBreakTime: "Total break time",
  infoForUser: "(Information for User)",
  weekModelSuccessfullyDeactivated: "weekly model was successfully deactivated",
  deactivateWeekModelMessage: "Do you really want to deactivate the weekly time model",
  showInactiveWeekModels: "Show deactivated weekly time models",
  hideInactiveWeekModels: "Hide deactivated weekly time models",
  deductTimeFrom: "deduct time from",

  //UserProjectPermissions.vue
  projectPerms: "Projectstages permissions and assignments",
  selectUserHint: "Select user",
  selectDepartmentHint: "Select department",
  selectUsersHint: "Mirror permission to the following users:",
  mirroringSubProject: "Mirror projectstage permission to the following users:",
  mirroringProject: "Mirror project permissions to the following users: (Only the stage permissions)",
  mirroringActivity: "Mirror activitytypes permissions to the selected users",
  mirroringActive: "Mirror permissions to other users",
  mirroringAll: "All",
  mirroringAllSelected: "Only selected",
  mirroringOnlySelectedProject: "Only selected project",
  mirroringOnlySelectedStage: "Only selected stage",
  mirroringOnlySelectedActivities: "Only selected activities",
  mirroringStage: "Mirror stage permissions to other users",
  mirroringAllStages: "All",
  mirroringAllActivities: "All",
  chooseMirroringType: "Please choose the permissions to mirror:",
  userProjectPermissionSearchState: "Search for status of the project",
  userProjectPermissionSearchCode: "Search for business partner code",
  userProjectPermissionSearchName: "Search for business partner name",
  searchCheckbox: "Do you want to search for projects?",
  noProjects: "No projects found or no projects available",
  searchDescriptionProject: "Search for projects:",
  businessPartnerCode: "Business partner code:",
  businessPartnerName: "Business partner name:",
  businessPartnerEmailAddress: "Business partner email:",
  permissionOnOff: "Permissions On/Off",
  errorOnlyNumbers: "In the field planned Costs and planned hours only numeric values are allowed. A maximum of only 10 numbers are allowed",
  stateStarted: "started",
  stateStopped: "stopped",
  statePaused: "paused",
  stateCanceled: "cancelled",
  stateFinished: "finished",
  plannedCosts: "Planned costs in € per hour",
  plannedTime: "Planned time in hours",
  successfullySetProjectPermissions: "Project Permissions were successfully saved for",
  successfullySetServiceCallPermissions: "Servicecall Permissions were successfully saved for",
  bpInfoFor: "Business Partner Information for",
  contactPerson: "Contact Person",
  postalAddress: "Postal Address",
  standardBillingAddress: "Standard Billing Address",
  bpTelephone: "Business Partner Phone Number",
  fax: "Fax",
  email: "Email",
  website: "Website",

  //UserServiceCallPermissions.vue
  serviceCallPermissions: "Servicecalls permissions and assignments",
  noServiceCalls: "No servicecalls available",
  noServiceTypes: "No activitytypes available",
  searchTitle: "Search:",
  stagesTitle: "Stages",
  serviceCallsTitle: "Servicecalls",
  serviceCallCreatedOn: "Servicecall created on",
  serviceCallStartedOn: "Servicecall started on",
  serviceCallMustEnd: "Must be closed on",
  statusAbgeschlossen: "Done",
  statusOffen: "Open",
  statusUnbekannt: "Unknown",
  statusAusstehend: "Pending",

  noBusinessPartners: "No business partners available",
  serviceCalls: "Servicecalls",
  activityTypes: "Activity Types",
  searchBusinessPartners: "Do you want to search for business partners?",
  searchDescriptionServiceCall: "Search for Servicecall:",
  searchDescriptionCustomer: "Search for business partner:",
  businessPartner: "Business partner",
  userServiceCallPermissionSearchState: "Search for status of the service call",
  userServiceCallPermissionSearchSubject: "Search for subject of the service call",
  mirroringServiceCallSelected: "Only selected servicecalls",
  mirroringServiceCallSelectedAll: "All from selected servicecall",
  mirroringCustomerSelected: "Only selected business partner",
  mirroringCustomer: "Mirror Business Partner - Servicecalls and Activitytype Permissions from the business partner to the selected users",
  mirroringServiceTypeSelected: "Only selected activities",
  mirroringAllSelectedCustomer: "All from selected business partner",
  mirroringServiceCall: "Mirror servicecall permission to the selected users",
  mirroringServiceType: "Mirror activitytypes permission to the selected users",
  userServiceCallPermissionSearchId: "Search for servicecall id",
  userServiceCallPermissionSearchCustomerCode: "Search for business partner code",
  userServiceCallPermissionSearchName: "Search for business partner name",
  //StageProjectDialog
  noProjectsWithPermission: "No projects with permissions found",
  noServiceCallsWithPermission: "No sevicecalls with permissions found",

  //TimeReport
  exportBtn: "Export",
  exportBtnAll: "Export All",
  exportType: "Export as",
  timeReport: "Time Report",
  selectTimeReport: "Select time report",
  monthly: "Monthly",
  timePeriod: "Time Period",
  timeBlocks: "Time Block",
  workingTime: "Working Time",
  timeIs: "Total Target Working Time",
  timeDebit: "Debit",
  targetWorkTime: "Target Working Time",
  timeBalance: "Balance",
  timeIsSum: "Total Actual Working Time",
  timeDebitSum: "Target Working Time",
  percent: "Difference in percent",
  autoModelTime: "Automodel Times",

  work: "Work",
  selectAllEmployees: "select all employees",
  help: "Help",
  holidays: "Yearly vacation days",
  logoNotUpdated: "Logo could not be changed!",
  absenceForDateAlreadyExists: "There is an absence for this date!",
  absenceAccountNotExists: "Without an vacation account there can't be an absence!",
  holidayAccount: "Vacation account",
  holidaysExpired: "Remaining annual leave to expire next year",
  closeTimemodel: "Remove Timeaccount",
  closeTimemodelDateWithClock: "Closing date (At 00:00 O'Clock)",
  closeTimemodelDate: "Closing date",
  createNewTimemodel: "Create new Timeaccount",
  takeOldBalance: "Take balance from previous Timeaccount",
  deleteTimemodelQuestion: "Do you really want to close the timeaccount at the specified date?",
  cancelDeleteTimemodelQuestion: "Do you really want to abort the closing of the timeaccount?",
  todayWorktime: "Today's working hours",
  hours: "Hours",
  worked: "Worked",
  totalVacation: "Totalvacation",
  vacationTakenPrevMonth: "Vacation taken previous months",
  vacationTakenThisMonth: "Vacation taken this month",
  remainingVacation: "Remaining vacation",
  open: "Available",
  planned: "Planned",
  taken: "Taken",
  unconfirmed: "Unconfirmed",
  days: "Days",
  showMonthlyHistorie: "Open monthly history",
  timeAccountIsClosing: "Timeaccount closing is noted!",
  timeModelNotSelected: "Timemodel is not selected",
  deleteTimemodelNowQuestion: "Do you really want to delete the timeaccount?",
  openBookingLinesWillBeDeleted: "The last booking lines will be deleted",
  employeeInformation: "Show informations",
  absenceNotPossibleBookingsAvailable: "Absence request is not possible. There is a booking for this date!",
  absenceForUserNotPossibleBookingsAvailable: "Absence request for {0} is not possible. There is a booking for this date!",
  absenceNotPossibleHolidayAvailable: "Absence request is not possible. There is a public holiday for this date!",
  userNotFoundPasswordNotMatch: "User not found or wrong password!",
  userIsInactiveInSAP: " Zugriff ist verweigert! Benutzer ist Inaktiv in SAP",
  dateWithAbsenceBookingNotPossible: "There is an absence for this day. Timebooking is not possible!",
  addDailyModel: "Add Daily Model",
  addWeeklyModel: "Add Weekly Model",
  addAutoWeekModel: "Add automatic Weekly Model",
  saveDailyModel: "Save Daily Model",
  saveWeeklyModel: "Save Weekly Model",
  newWeeklyModel: "New Weekly Model",
  newAutoWeeklyModel: "New Automatic Weekly Model",
  weeklyModelName: "Weekly Model Name",
  timeIsRequired: "Time is required",
  newDailyModel: "New Daily Model",
  dailyModelNotSelected: "Daily model was not selected!",
  timemodelName: "Daily Model name",
  debitWorkTime: "Target Working Time",
  remark: "Remark",
  worktime: "Worktime",
  flexTime: "Flex Time",
  pauses: "Pauses",
  inHours: "in hours",
  weeklyWorkTime: "Target Weekly Work Time",
  stages: "Stages",
  noPermission: "No Permission!",
  wrongOTPToken: "Wrong token!",
  passwordSettings: "Password Settings",
  enable: "Enable",
  activateOTP: "Activate two-factor authentication",
  nameIsRequired: "Name is required",
  maximumCharacterLengthReached: "Maximum character length reached",
  editDailyModel: "Edit Daily Model",
  editWeeklyModel: "Edit Wekly Model",
  newEditWeeklyModel: "Edit automatic Weekly Model",
  startHolidays: "Starting holidays from {0}",
  userHolidaysFrom: "Holidays days from {0}",
  holidaysUsed: "Holidays taken",
  holidaysPlanned: "Holidays planned",
  holidaysBooked: "Holidays booked",
  lastYearUserHolidays: "Remaining vacation from last year ",
  restHolidays: "Remaining holiday",
  changeStartTime: "Do you really want to change the starting value? This will correct every timeaccount booking! This will take some time!",
  oneChangeByTimeAccount: "Do you really want to change the {0}? This will correct every timeaccount booking! This will take some time!",
  timeAccountStartValue: "starting value",
  timeAccountStartDate: "starting date",
  timeAccountModell: "time model",
  twoChangesByTimeAccount: "Do you really want to change the {0} und {1}? This will correct every timeaccount booking! This will take some time!",
  changeStartTimeAndStarDateAndWeekModel:
    "Do you really want to change starting value, starting date und time model ändern? This will correct every timeaccount booking! This will take some time!",
  timeAccountNotUpdated: "TimeAccount could not be changed!",
  pinLoginNotAllowed: "PIN Login not allowed!",
  noHolidayAccount: "The employee has no annual leave account!",
  noHolidayAccountForUser: "{0} has no holidayaccount!",

  enterYearlyHolidays: "Bitte jährliche Urlaubstage eintragen!",
  couldntAddOTPToUser: "Could not activate OTP for user!",
  deactivate: "Deactivate",
  activate: "Activate",
  twoFactorInfo1: "Don't wait for activating the two factor authentification!",
  twoFactorInfo2: "It is not hard to activate and it will help secure your personal account!",
  twoFactorInfo3: "Also you get the benefit to login into your account with an 4 digit pin. (+6 digit OTP Token)",
  twoFactorInfo4: "You then don't need to remember a complex password. Only a simple 4 digit pin.",
  twoFactorInfo5: "The 2-Factor Authentication is optional but you will benefit from it with adding a second security layer to your account.",
  twoFactorScanCodeInfo: "Scan this QR Code with your phone and type in the resulting OTP code from your phone!",
  enableTwoFactor: "Activate 2-Factor Authentication",
  twoFactor: "2-Factor Authentication",
  status: "Status",
  enterOTPCode: "Please enter the one time password from the authenticator app!",
  enterCorrectStartTimeFormat: 'Wrong Format ("+/- HH:mm")',
  showPin: "Show own Loginpin!",
  showPinInfo: "Do you really want show your login pin? Watch out that only you can see your own pin and no one else!",
  hidePin: "Hide login pin!",
  emptyTimeAccountOnMonthStart: "Empty time account at the beginning of the month (e.g. for temporary staff)",
  cutWorkingTime: "Capping working hours",
  cutStartTime: "Capping start time",
  cutEndTime: "Capping end time",
  deductBreakTimes: "Automatically deduct break times",
  noActiveTimeAccount: "No active Timeaccount. Please add an timeaccount to insert bookinglines.",
  timeModels: "Time Models",
  addAbsence: "Add absence",
  absenceAsAdmin: "Can't add absence as admin user!",
  removeVacation: "Remove vacation",
  removeAbsence: "Remove absence",
  addReasonAbsence: "Add absencereason",
  removeAbsenceQuestion: "Do you want to remove this absence?",
  addAbsenceReasons: "Add absence reasons",
  designation: "designation",
  red: "Red",
  purple: "Purple",
  blue: "Blue",
  cyan: "Cyan",
  indigo: "Indigo",
  violet: "Violet",
  orange: "Orange",
  deepOrange: "Deep orange",
  brown: "Brown",
  lime: "Lime",
  amber: "Amber",
  blueGrey: "Blue grey",
  teal: "Teal",
  deepPurple: "Deep purple",
  checkInput: "Please verify that your input is correct!",
  pleaseSelectIcon: "Please select an icon!",
  pleaseSelectColorCode: "Please select a color code!",
  pleaseSelectName: "Please enter a name!",
  chooseLocation: "select location",
  statusInHouse: "In House",
  statusOut: "Out of House",
  statusVacation: "In Vacation",
  statusHomeOffice: "In Home Office",
  statusIll: "Ill",
  statusUnknown: "Unknown",
  noDepartment: "No Assigned Department",
  addAttachment: "Add attachment",
  noBlanksError: "no blanks",

  // Setup
  pleaseRestartServiceLayer: "Please restart ServiceLayer and confirm this dialog. The COBI.time service will then restart!",
  notInSetupMode: "Server is not in Setup Mode!",
  serviceNotReachablePleaseRefresh: "Connection to COBI.time Service failed! Please refresh this website!",
  installSuccessfull: "COBI.time installation/update was successfully! The website will refresh!",
  installSuccessfullPleaseRefresh: "COBI.time installation/update was successfully! Please refresh the website manually!",
  serviceLayerRestartedSuccessfully: "ServiceLayer restarted successfully! The website will refresh!",
  changelog: "Introduction / Changelog",
  tables: "Tables",
  execute: "EXECUTE",
  tableFields: "Fields",
  tableData: "Data",
  setupUpdate: "Setup / Update",
  publicHolidayManagement: "Public Holiday Management",
  faceNotFound: "Face not found!",
  faceRecognitionDisabled: "Face Recognition is deactivated or not configured properly!",
  tryFaceLogin: "Try Login with face data. Please wait...",
  deleteProfilePicture: "Delete profile picture",
  deleteProfilePictureQuestion: "Do you really want to delete that profile picture?",
  showFaceHelpText: "Please place your face in the central and do not move...",
  reportType: "Reporttype",

  // Useradministration.vue
  // StageProjectDialog
  costCenter: "Cost Center",
  chooseCostCenter: "Choose Cost Center",
  representative: "Deputy",
  manager: "Manager",

  // PopUpEditStages.vue
  editActivityTypes: "Edit Activity Types",

  // EventLog.vue
  eventLogs: "Event Logs",
  filterColumns: "Filter Columns",
  filter: "Filter",
  columnSelection: "Selected columns",
  breadcrumbsFilter: "Selected Filters",
  logfileExport: "Export Logfile",
  noEventLogEntries: "There are no Event Logs for the specified date.",
  pageSize: "Page Size",
  dataRefreshed: "Data successfully refreshed",
  timeCorrectionBy: "Time Correction by",
  wasAssignedNewTimeAccount: "was assigned a new time account",
  activeFrom: "Active starting from",
  dataRefreshConfirm:
    "This action will take a long time. Do you want to continue? You can keep using the site while the data is being refreshed. Changing the dates to include a smaller range will redude load times.",
  dateRangeError: "End date must be greater than start date",
  cancelled: "Cancelled",
  removeBreadCrumb: "Remove filter",
  dateFrom: "From",
  dateUntil: "Until",

  //EventLog Transaction Types
  EditUserRights: "User Permissions Edited",
  WorkStatus: "Work Status",
  TimeCorrection: "Time Correction",
  by: "by",

  // EventLog Headers
  U_severity: "Severity",
  U_name: "Username",
  U_type: "Transaction Type",
  U_date: "Date",
  U_time: "Time",
  U_status: "Status",
  WorkStart: "Work started",
  WorkEnd: "Work ended",
  PauseStart: "Break started",
  PauseEnd: "Break ended",
  ProjectStart: "Project started",
  ProjectEnd: "Project ended",
  ProjectPauseStart: "Project Break started",
  ProjectPauseEnd: "Project Break ended",
  details: "Details",
  AbsenceRequest: "Absence Request",

  // EventLog UserEditRights
  revoked: "revoked",
  granted: "granted",
  admin: "Admin",
  user: "User",
  projectUser: "Projectbooking",
  manualTimeKeeping: "Manual Timekeeping",
  employeeManager: "Employee Manager",
  presenceList: "Presencelist",
  presentList: "Presencelist",
  presenceListAll: "Presencelist (all)",
  timeCorrection: "Time Correction",
  canSeeEmployeeTimes: "Can see Employee Times",
  projectAndBreakTimeManipulation: "Can manipulate Project- and Break-Times",
  canChangeBusinessTripTime: "Can change Business Trip Time",

  userRight: "Permission",

  // Dynamic List
  elementsSelected: "Elements selected",
  elementSelected: "Element selected",

  // General Reporting
  refresh: "Refresh",
  generalReporting: "General Reporting",
  workTimeReport: "Work Time Report",
  vacationReport: "Absence Report",
  teams: "Teams",
  U_project: "Project",
  U_businessTrip: "Business Trip",
  // not sure if we need this
  U_employeeId: "Employee Number",
  U_extID: "Ext. Employee Number",

  detailedReport: "Detailed Report",
  dailyReport: "Daily Report",
  weeklyReport: "Weekly Report",
  monthlyReport: "Monthly Report",
  yearlyReport: "Yearly Report",
  evaluationReport: "Evaluation Report",
  greaterThan: "Greater than",
  lessThan: "Less than",

  U_workTime: "Work Time",
  U_breakTime: "Break Time",
  U_businessTripTime: "Business Trip Time",
  U_projectTime: "Project Time",
  U_totalTime: "Total Time",
  U_absenceTime: "Absence Time",
  U_paidAbsenceTime: "Paid Absence Time",
  U_unpaidAbsenceTime: "Unpaid Absence Time",
  U_requiredTime: "Required Time",
  calendarWeek: "Calendar Week",
  actualTime: "Actual Time",
  U_difference: "Difference",
  U_ratio: "Ratio",
  U_coming: "Coming",
  U_leaving: "Leaving",
  U_sumIs: "Sum (is)",
  U_sumWas: "Sum (was)",
  U_debit: "Balance",
  timeAccountCorr: "Balance correction",

  noDataAvailable: "No data available",
  noDataAvailableForSelectedParameters: "No data available for selected parameters.",
  resetFilter: "Reset filter",

  // Months
  month_Jan: "January",
  month_Feb: "February",
  month_Mar: "March",
  month_Apr: "April",
  month_May: "May",
  month_Jun: "June",
  month_Jul: "July",
  month_Aug: "August",
  month_Sep: "September",
  month_Oct: "October",
  month_Nov: "November",
  month_Dec: "December",

  // WorkTimeSummary
  workTimeSummary: "Work Time Summary",
  workTimeWas: "Carryover from previous period",
  workTimeIs: "New time account balance",
  U_department: "Department",
  U_weekday: "Weekday",
  U_average: "Average",

  // AbsenceReport
  vacationReportNotSameYear: "An absence report can not be generated across multiple years",
  U_reason: "Reason",
  U_factor: "Factor",
  U_countAsWorkingTime: "Paid/Unpaid",
  paid: "Paid",
  unpaid: "Unpaid",
  U_openVacation: "Open Vacation",
  U_usedVacation: "Used Vacation",
  U_totalVacation: "Total Vacation",
  U_comment: "Comment",

  U_memberCount: "Member Count",

  perUserReport: "User Report",
  perDepartmentReport: "Department Report",
  usedVacationForSelectedPeriod: "Used Vacation(for selectedPeriod)",

  fetchingData: "Fetching data",
  processingData: "Processing data",

  // Misc
  selectAll: "Select All",

  // User Report
  calenderWeek: "CW",
  weekDay: "Day",
  timeTotal: "Work Time",
  presentTime: "Presence Value",
  absenceTime: "Absence Time",
  businessTripTime: "Business Trip Time",
  timeRequired: "Required Time",
  comeAndGoTimes: "Come + Go",
  breakTimeTotal: "Total Break Time",
  breaks: "Breaks",
  activitiesTotalTime: "Activities Time",
  activities: "Activities",
  dayBalance: "Difference",
  timeBalanceAbb: "Balance",
  timeAccountCorrections: "Balance Correction",
  publicHolidaysAbb: "Public Holiday",
  overallPeriod: "Overall Period:",

  calenderWeekExplain: "Calender Week",
  weekDayExplain: "Day",
  timeTotalExplain: "Work Time",
  presentTimeExplain: "Presence value",
  timeRequiredExplain: "Requried Time",
  comeAndGoTimesExplain: "Come + Go",
  breakTimeTotalExplain: "Total break times",
  breaksExplain: "break times",
  activitiesTotalTimeExplain: "Actvities times",
  activitiesExplain: "Actvities",
  dayBalanceExplain: "Difference",
  timeBalanceAbbExplain: "Balance",
  timeAccountCorrections: "Balance Correction",
  holidayExplain: "Holiday",
  illnessExplain: "illness",
  publicHolidaysAbbExplain: "Public holidays",
  otherAbsencesExplain: "Other absences",
  dateExplain: "Date",
  transferFromWorkTime: "Transfer from Work Time",
  newBalance: "New Balance",
  previousMonthBalance: "Previous Month Balance",
  newBalance: "New Balance",
  descriptions: "Descriptions",
  timeValue: "Time Value",
  total: "Total",
  vacationSummary: "Vacation Summary",
  absencesSummary: "Absence Summary",

  pinUnlock: "Pin unlock",
  passwordForPinUnlockIncorrect: "Password for pin unlock is wrong!",
  timeoutSeconds: "Timeout seconds",
  presentEmployeesTooltip: "Present employees (incl. during the break) <br> In House: {0} <br> In Home Office: {1} <br> Out of House: {2}",
  absenceEmployeesTooltip: "Absent employees",

  connectWasSuccessful: "Connected with SAP",
  connectionHasFailed: "Connection to SAP failed",
  connectingToSAP: "Connecting to SAP"
};
